export const getSortItems = (platformUsersIndexName) => {
  return [
    {
      value: platformUsersIndexName,
      label: "Default",
    },
    {
      value: `${platformUsersIndexName}_createdAt_dt_desc`,
      label: "Date Joined (desc)",
    },
    {
      value: `${platformUsersIndexName}_createdAt_dt_asc`,
      label: "Date Joined (asc)",
    },
    {
      value: `${platformUsersIndexName}_rate_desc`,
      label: "Rate (desc)",
    },
    {
      value: `${platformUsersIndexName}_rate_asc`,
      label: "Rate (asc)",
    },
  ];
};
